import {useIsAnyOverlayOpen} from '@aboutyou/opened-state-manager';
import {
  useIsBasketPage,
  useIsCheckoutPage,
  useIsOrderSuccessPage,
} from '@aboutyou/router';
import {useCallback, useEffect, useState} from 'react';
import {useUserSessionCount} from '../../../../client-services/SessionCountProvider/SessionCountProvider';
import {DevicePushState} from '../../../../features/useDevicePushState/enums/DevicePushState';
import {useDevicePushState} from '../../../../features/useDevicePushState/useDevicePushState';
import {useDidAskPushNotification} from '../../hooks/useDidAskPushNotification';
import {useIsPushNotificationEnabled} from '../../useIsPushNotificationEnabled';

export const TIME_UNTIL_LONG_SESSION_TRIGGER_SHOW = 3 * 60 * 1000; // 3 minutes

export const useShouldShowLongSessionTrigger = () => {
  const [openFlyout, setOpenFlyout] = useState(false);
  const {userSessionCount} = useUserSessionCount();

  const {isPushNotificationReturnCountMet, updateCountAfterFlyoutOpened} =
    useDidAskPushNotification({
      minimumAmountBeforeTrigger: 1,
      userSessionCount: userSessionCount.count,
    });
  const {devicePushState} = useDevicePushState();

  const isBasketPage = useIsBasketPage();
  const isCheckoutPage = useIsCheckoutPage();
  const isOsp = useIsOrderSuccessPage();
  const isPushNotificationEnabled = useIsPushNotificationEnabled();

  const isAnythingOpen = useIsAnyOverlayOpen();

  const onClose = useCallback(() => {
    setOpenFlyout(false);
    updateCountAfterFlyoutOpened();
  }, []);

  useEffect(() => {
    const timeout = setTimeout(() => {
      // eslint-disable-next-line local-rules/set-state-in-use-effect
      setOpenFlyout(true);
    }, TIME_UNTIL_LONG_SESSION_TRIGGER_SHOW);
    return () => clearTimeout(timeout);
  }, []);

  if (
    !isPushNotificationReturnCountMet() ||
    !openFlyout ||
    devicePushState !== DevicePushState.NOT_SENT ||
    !isPushNotificationEnabled ||
    isBasketPage ||
    isCheckoutPage ||
    isOsp ||
    isAnythingOpen
  ) {
    return {
      shouldShow: false,
      onClose,
    };
  }

  return {
    shouldShow: true,
    onClose,
  };
};
